module.exports = __webpack_public_path__ + "media/images/icons/outlined/holder-229caca8c9e712b118bb199ee8649a8a.svg";